import { z } from "zod/v4";

const EarDataSchema = z.array(
  z.object({
    earid: z.number().optional(),
    apriori: z.boolean().optional(),
    earFiles: z.array(
      z.object({
        file: z.any().optional(),
        fileType: z.string().optional(),
        fileLabel: z.string().optional(),
      }),
    ),
  }),
);

const EarRequiredSchema = z
  .object({
    ear_required: z.literal(true),
    no_ear_justification: z.string().length(0),
    earData: EarDataSchema,
  })
  .check(({ value, issues }) => {
    //basically we check if ear_required and they have ears, they at least add one ear file
    // this error shows up every time they add an ear
    if (value.ear_required && value.earData) {
      value.earData.forEach((ear, index) => {
        if (ear.earFiles.length === 0) {
          issues.push({
            code: "custom",
            message: "File Upload is required",
            input: ear.earFiles,
            path: [`earData.${index}.earFiles`],
          });
        }
      });
    }
  });

const EarNotRequiredSchema = z.object({
  ear_required: z.literal(false),
  no_ear_justification: z
    .string()
    .min(1, "Justification required if no EAR is required"),
  earData: EarDataSchema,
});

export const EarSchema = z.discriminatedUnion("ear_required", [
  EarRequiredSchema,
  EarNotRequiredSchema,
]);

export const EarDraftSchema = z.object({
  ear_required: z.boolean(),
  no_ear_justification: z.string(),
  earData: EarDataSchema,
});
